import React from "react";
import ProjectsCard from "./ProjectsCard";
import { FaReact, FaNodeJs, FaDatabase, FaDocker, FaServer, FaMapMarkerAlt } from "react-icons/fa";
import {
  SiTailwindcss,
  SiMongodb,
  SiTypescript,
  SiFirebase,
  SiRedux,
  SiAwslambda,
  SiPostgresql,
  SiVercel,
  SiRazorpay,
  SiJavascript,
  SiExpress,
  SiPm2,
  SiSocketdotio,
  SiGooglemaps,
  SiNamecheap,
  SiStripe,
} from "react-icons/si";
import { TbApi } from "react-icons/tb";
import Title from "../layouts/Title";

const ProjectsSection = () => {
  const projects = [
    {
      id: 1,
      title: "Divsly",
      shortDescription:
        "Developed Divsly, a digital marketing platform offering URL shortening, QR codes, link management, and campaign tools for enhanced user engagement.",
      description:
        "Divsly is a comprehensive digital marketing platform I developed while working at a programming studio. It encompasses a range of features including URL shortening with tracking, custom QR code generation, efficient link management, and various campaign tools for SMS, email, and WhatsApp marketing. The platform was designed to provide users with streamlined marketing solutions and enhanced engagement capabilities.",
      thumbnail: "/projects/divsly-1.png",
      images: [
        "/projects/divsly-1.png",
        "/projects/divsly-2.png",
        "/projects/divsly-3.png",
        "/projects/divsly-4.png",
        "/projects/divsly-5.png",
        "/projects/divsly-6.png",
        "/projects/divsly-7.png",
        "/projects/divsly-8.png",
        "/projects/divsly-9.png",
        "/projects/divsly-10.png",
      ],
      technologies: [
        { name: "React", icon: <FaReact /> },
        { name: "Node.js", icon: <FaNodeJs /> },
        { name: "Express JS", icon: <FaServer /> },
        { name: "PostgreSQL", icon: <SiPostgresql /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "REST API", icon: <TbApi /> },
        { name: "Tailwind CSS", icon: <SiTailwindcss /> },
        { name: "Vercel", icon: <SiVercel /> },
        { name: "Razorpay", icon: <SiRazorpay /> },
      ],
      features: [
        "URL Shortening: Creation of concise, trackable URLs with analytics to monitor performance (click-through rates, location data, etc.).",
        "Custom QR Code Generation: Ability to create branded and functional QR codes for various marketing purposes.",
        "Link Management: Tools for organizing, optimizing, and managing multiple online links.",
        "SMS Marketing: Functionality to conduct marketing campaigns via SMS messaging.",
        "Email Marketing: Features to design and execute email marketing campaigns.",
        "WhatsApp Campaigns: Tools to engage audiences directly through WhatsApp.",
        "Razorpay Integration: Seamless integration of the Razorpay payment gateway for secure online payment processing.",
        "500+ Integrations: Compatibility with a wide range of external tools and platforms."
      ],
      testimonial: {
        text: "We love the ability to create branded short links and custom QR codes with Divsly. It adds a professional touch to our marketing materials and has improved user trust. The integration of Razorpay has made transactions seamless for our customers.",
        // name: "Sarah Johnson",
        // position: "CEO, Fashion Boutique",
        // avatar: "/images/testimonial1.jpg",
      },
      // githubLink: "https://github.com/yourusername/ecommerce-platform",
      liveLink: "https://divsly.com/",
    },
    {
      id: 2,
      title: "TripHog",
      shortDescription:
        "TripHog is a complete transport management system with web and mobile solutions for medical transit companies.",
      description:
        "TripHog is a comprehensive transportation management platform I developed to streamline medical transit operations. The web portal serves as the central hub where admins can manage routes, track drivers in real-time, handle scheduling, and access all system data. My contribution focused on creating an intuitive web interface that communicates seamlessly with the driver and patient mobile apps, ensuring smooth information flow and operational efficiency.",
      thumbnail: "/projects/triphug/triphug-1.png",
      images: ["/projects/triphug/triphug-1.png", "/projects/triphug/triphug-2.png","/projects/triphug/triphug-3.png","/projects/triphug/triphug-4.png","/projects/triphug/triphug-5.png"],
      technologies: [
        { name: "JavaScript", icon: <SiJavascript /> },
        { name: "React", icon: <FaReact /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "Node JS", icon: <FaNodeJs /> },
        { name: "Express JS", icon: <SiExpress /> },
        { name: "Namecheap", icon: <SiNamecheap /> },
        { name: "REST API", icon: <TbApi /> },
        { name: "Tailwind CSS", icon: <SiTailwindcss /> },
        { name: "PM2", icon: <SiPm2 /> },
        { name: "Socket.io", icon: <SiSocketdotio /> },
        { name: "Razorpay", icon: <SiRazorpay /> },
        { name: "Google Maps", icon: <SiGooglemaps /> },

      ],
      features: [
        "One-Click Trip Uploads: Developed the user interface for quick and easy submission of trip details via the web.",
        "Customizable Administrative Dashboards: Built adaptable web views to manage various transportation needs, including route optimization, patient management, and driver tracking.",
        "Instant Signature Capture Interface: Implemented the web component for viewing and managing digitally captured patient and driver signatures.",
        "Automated Log Management: Contributed to the web interface for viewing and accessing automatically generated trip logs with GPS timestamps.",
        "Driver Tracking Map Integration: Integrated GPS tracking data into a web-based map interface for real-time driver location monitoring.",
        "Secure Document Repository: Developed the web interface for a centralized system allowing administrators and drivers to securely store, access, and retrieve trip-related documents.",
        "Remote Team Access: Ensured a seamless and accessible web experience for team members working remotely.",
        "HR and Payroll Management Interface: Developed web-based tools for managing employee information, tracking working hours, and processing payroll.",
        "Admin Messaging System: Implemented the web interface for real-time communication between drivers, patients (potentially via admin), and the admin office."
      ],
      testimonial: {
        text: "The web portal developed for TripHog transformed how we manage our medical transport business. The intuitive interface made training our staff simple, while the powerful backend features gave us unprecedented control over operations. Real-time driver tracking and automated logging saved us countless hours of administrative work. The developer understood our unique challenges and delivered a solution that exceeded our expectations in both functionality and ease of use. Thank you for your exceptional work.",
        name: "Muhammad Wahab",
        position: "CEO, Mastery Softwares",
        avatar: "/projects/triphug/wahab.png",
      },
      // githubLink: "https://github.com/yourusername/task-manager",
      liveLink: "https://triphog.net/",
    },
    {
      id: 3,
      title: "Wedbliss",
      shortDescription:
        "WedBliss is an all-in-one wedding planning platform that connects couples with vendors for every wedding need.",
      description:
        "WedBliss is a comprehensive wedding planning platform I developed for my final year university project. Built using the MERN stack (MongoDB, Express.js, React.js, and Node.js), this platform bridges the gap between couples planning their special day and various wedding service providers. The web application allows users to browse, compare, and book services ranging from venues and catering to photography and invitation cards, all in one place. WedBliss simplifies the overwhelming wedding planning process by creating a centralized marketplace where couples can manage their budget, track progress, and communicate with vendors directly through the platform.",
      thumbnail: "/projects/wedbliss/wedbliss-1.png",
      images: [
        "/projects/wedbliss/wedbliss-1.png",
        "/projects/wedbliss/wedbliss-2.png",
        "/projects/wedbliss/wedbliss-3.png",
        "/projects/wedbliss/wedbliss-4.png",
        "/projects/wedbliss/wedbliss-5.png",
        "/projects/wedbliss/wedbliss-6.png",
        "/projects/wedbliss/wedbliss-7.png",
      ],
      technologies: [
        
          { name: "Node.js", icon: <FaNodeJs /> },        // Correct
          { name: "Express.js", icon: <SiExpress /> },     // Using Simple Icons for Express
          { name: "React", icon: <FaReact /> },           // Correct
          { name: "MongoDB", icon: <SiMongodb /> },        // Correct
          { name: "Leaflet", icon: <FaMapMarkerAlt /> },   // Using Font Awesome for a map marker
          { name: "Socket.io", icon: <SiSocketdotio /> },    // Correct
          { name: "Stripe", icon: <SiStripe /> },          // Correct
          { name: "Google Maps", icon: <SiGooglemaps /> },   // Correct
          { name: "REST API", icon: <TbApi /> },           // Correct (Tabler Icons)
          { name: "Tailwind CSS", icon: <SiTailwindcss /> }, // Correct
          { name: "PM2", icon: <SiPm2 /> },              // Correct
          { name: "Vercel", icon: <SiVercel /> },         // Correct
        

      ],
      features:[
        "User-friendly dashboard for wedding planning progress tracking",
        "Vendor discovery and comparison tools",
        "Secure online payment system",
        "Budget management calculator",
        "Wedding timeline and checklist creator",
        "Direct messaging between couples and vendors",
        "Vendor profiles with portfolios, reviews, and availability calendars",
        "Favorite lists for shortlisting preferred services",
        "Filter options by location, price range, and style preferences",
        "Mobile-responsive design for planning on the go"
      ],
      testimonial: {
        text: "WedBliss demonstrates exceptional technical implementation of the MERN stack while addressing a real market need. The student showed strong problem-solving skills by creating an intuitive platform that successfully connects wedding service providers with couples. The user interface is clean, responsive, and thoughtfully designed with the end-user in mind. We were particularly impressed by the payment integration and messaging features. This project not only meets but exceeds our expectations for a final year submission, showing both technical proficiency and market awareness.",
        name: "Dr. Ehsan Ullah Munir", 
        position: "Project Supervisor, Comsats University Islamabad",
        avatar: "/projects/wedbliss/comsats.jpg",
      },
      // githubLink: "https://github.com/yourusername/cloud-microservices",
      liveLink: "https://www.youtube.com/watch?v=WkSsXoCjTis",
    },
    
  ];

  return (
    <section id="projects" className="py-20 bg-bodyColor">
      <div className="container mx-auto px-4">
        <div className="flex justify-center items-center text-center">
          <Title
            title="Check out some of the projects I've built"
            des="My Recent Projects"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
          {projects.map((project) => (
            <ProjectsCard key={project.id} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
